module.exports = __webpack_public_path__ + "static/img/qltdapp.2545fc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qltdapp.png
// module id = jIEG
// module chunks = 0